/*
 *
 * Package: `@dbh/development-bar-theme`.
 *
 */const THEME_KEY_DEVBAR="devBar";const modifyDevBarTheme=a=>{let{fonts:{lineHeight:{l2:b}}}=a;return {[THEME_KEY_DEVBAR]:{button:{lineHeight:b}}}};

export { THEME_KEY_DEVBAR, modifyDevBarTheme as default };
